import './SentToSwitch.scss';

const SentToSwitch: React.FC = () => {
  return (
    <div className="ie-sent-to-switch">
      <div className="ie-sent-to-switch__text-container">
        <span className="ie-sent-to-switch__label">Отправлять в</span>
        <strong className="ie-sent-to-switch__value">Лизинг</strong>
      </div>
    </div>
  );
};

export default SentToSwitch;
